import { Component, Input, OnInit } from '@angular/core';
import { ChartBaseDirective } from '@client/app/modules/charts/directives/chart-base.directive';
import { DEFAULT_CHART_SETTINGS } from '@client/app/modules/charts/constants/Chart.constant';
import { LegendCursorService } from '@client/app/modules/charts/services/LegendCursor.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'mon-chart-bar',
    templateUrl: './bar.component.html',
    standalone: true,
    imports: [
        ChartBaseDirective,
        CommonModule,
    ],
})
export class BarComponent implements OnInit {
    @Input() emptyDataMessage: string = '';
    @Input() labels: any[] = [];
    @Input() data: any[] = [];
    @Input() series: any[] = [];
    @Input() override?: any[] | undefined = undefined;
    @Input() options?: any | undefined = undefined;
    @Input() height: any = '';
    @Input() colors: any[] = [];
    @Input() loading: boolean = false;

    constructor (
        private legendCursorService: LegendCursorService,
        private translateService: TranslateService,
    ) {}

    ngOnInit (): void {
        this.height = this.height || DEFAULT_CHART_SETTINGS.CHART.HEIGHT.toString();
        this.emptyDataMessage = this.emptyDataMessage || this.translateService.getString('No data present');
        this.loading = this.loading || false;
        this.options = this.legendCursorService.setHoverState(this.options || {});
    }

    areAllDataRowsEmpty (): boolean {
        if (!Array.isArray(this.data)) {
            return true;
        }

        for (let i = 0; i < this.data.length; i++) {
            if (Array.isArray(this.data[i])) {
                if (this.data[i].length > 0) {
                    return false;
                }
            } else {
                return false;
            }
        }
        return true;
    }
}
